export enum AlertHubMethods {
	LockerGateStatusChanged = 'LockerGateStatusChanged',
	AlarmZoneStatusChanged = 'AlarmZoneStatusChanged',
	MSpaceLockOpened = 'MSpaceLockOpened',
	MSpaceLockNotOpened = 'MSpaceLockNotOpened',
}
